// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('brRegView', {
//         templateUrl: 'views/components/views/brRegView/brRegView.template.html?v=' + module.version,
// 		controllerAs: 'vm',
//         controller: ['$stateParams', 'base64', 'stateService', 'translateService', 'modalService', 'brRegViewService', 'economyService', 'logisticService', function ($stateParams, base64, stateService, translateService, modalService, brRegViewService, economyService, logisticService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orgNo = $stateParams.orgno;
//             let resourceId = $stateParams.resource_id;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

// 			vm.model = {
//                 customerGroupButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('custgrps') }
//                 ],
//                 customerBusinessButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('businesss') }
//                 ],
// 				edit: {},
// 				selectListCustomerGroups: [],
// 				selectListBusinesses: [],
// 				lockedSave: false
// 			};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             function loadOrganizationNumbers() {
// 				let organizationUrl = 'https://data.brreg.no/enhetsregisteret/api/enheter?organisasjonsnummer=' + orgNo;
// 				let xhr = new XMLHttpRequest();

// 				xhr.open('GET', organizationUrl, true);
// 				xhr.send();
// 				xhr.onreadystatechange = processRequest;

// 				async function processRequest(e) {
// 					if (xhr.readyState == 4 && xhr.status == 200) {
// 						let response = xhr.responseText;
						
//                         vm.model.edit = (await brRegViewService.getEdit({
//                             response: base64.urlencode(response),
//                             resource_id: resourceId
//                         }))[0];
// 					}
// 				}
// 			}

//             async function loadCustomerGroups() {
//                 vm.model.selectListCustomerGroups = await economyService.listCustomerGroups({ add_all: '0' });
//             }

//             async function loadBusinesses() {
//                 vm.model.selectListBusinesses = await logisticService.listBusinesses();
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

// 			// #region WINDOW OPEN FUNCTION

// 			vm.openWebLink = function () {
// 				let proffNo = 'https://www.proff.no/bransjesøk?q=' + orgNo;
// 				window.open(proffNo);
// 			}

//             // #endregion WINDOW OPEN FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 brRegViewService.saveObj(vm.model.edit).then((response) => {
//                     if (response[0] && response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 loadOrganizationNumbers();
//                 loadCustomerGroups();
//                 loadBusinesses();
//             }

//             // #endregion ON INIT FUNCTION

// 		}]
// 	});
// })();
